<template>
    <div class="financial-assets">
        <div class="assets-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">{{ specialmoudulename }}总资产</span>
            </div>
        </div>
        <div class="assets-info">
            <div v-for="(item, index) in amountTypes" :key="index" class="assets-item">
                <div class="amount-type">
                    {{ item.text }}
                </div>
                <div v-if="index == 0" class="assets-text">
                    {{ $util.fmtNum(item.val) }}
                </div>
                <div
                    v-else
                    class="assets-text"
                    :class="item.val > 0 ? 'add' : item.val < 0 ? 'reduce' : ''"
                >
                    {{ $util.fmtNum(item.val) }}
                </div>
            </div>
        </div>
        <div class="assets-title">
            <div style="display: flex; align-items: center; margin-top: 50px">
                <div class="title-line"></div>
                <span class="title-content">持有{{ specialmoudulename }}资产明细</span>
            </div>
        </div>
        <el-row v-if="assets.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>暂无数据</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="基金名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name">
                        <el-tooltip effect="info" :content="scope.row.fundname" placement="top">
                            <span>{{ scope.row.fundname }}</span>
                        </el-tooltip>
                    </div>
                    <div style="color: #999999; display: flex; align-items: center">
                        <div>{{ scope.row.fundcode }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="销售机构" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.distributorname }}</span>
                </template>
            </el-table-column>
            <el-table-column label="最新净值" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="参考市值(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持仓盈亏(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentprofit) }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" align="center" min-width="160">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-tooltip
                            v-if="scope.row.isBuy"
                            class="item"
                            effect="info"
                            :content="
                                scope.row.isBuy +
                                '，不能' +
                                (scope.row.status == '1' ? '认购' : '申购')
                            "
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">
                                {{ scope.row.status == "1" ? "认购" : "申购" }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{ scope.row.status == "1" ? "认购" : "申购" }}
                        </el-button>
                        <div class="line"></div>
                        <el-tooltip
                            v-if="scope.row.isSell"
                            class="item"
                            effect="info"
                            :content="scope.row.isSell"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">
                                {{ scope.row.bookingredeem == "1" ? "预约赎回" : "赎回" }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="scope.row.bookingredeem == '1'"
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('25', scope.row)"
                        >
                            预约赎回
                        </el-button>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            赎回
                        </el-button>
                        <div v-if="scope.row.sourceflag != '2'" class="line"></div>
                        <el-button
                            v-if="scope.row.sourceflag != '2'"
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column
                v-if="checkNoticeFlag || checkNavFlag"
                label="详情"
                align="center"
                min-width="160"
            >
                <template slot-scope="scope">
                    <div class="btns">
                        <el-button
                            v-if="checkNoticeFlag"
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showNotice(scope.row)"
                        >
                            公告
                        </el-button>
                        <div v-if="checkNoticeFlag && checkNavFlag" class="line"></div>
                        <el-button
                            v-if="checkNavFlag"
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showNav(scope.row)"
                        >
                            历史净值
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import format from "date-fns/format";

export default {
    name: "MyFinancialAssets",
    components: {},
    mixins: [mixin],
    data() {
        return {
            specialmoudulename: "",
            conf: {}, // 初始化配置文件内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            amountTypes: [
                {
                    text: "资产总计(元)",
                    val: ""
                }
                // {
                //     text: "最新收益(元)",
                //     val: ""
                // },
                // {
                //     text: "累计收益(元)",
                //     val: ""
                // }
            ], // 金额类型
            sourceflag: null, // 购买渠道
            selectIndex: 0, // 选中资产类型下标
            curPage: 1, // 当前页
            date: "", // 当前日期
            hasLoad: false, // 是否已经查询数据
            assetshowtype: 0,
            sdxFundInfo: {},
            checkNoticeFlag: false, // 专户公告菜单是否开放
            checkNavFlag: false // 专户净值菜单是否开放
        };
    },
    watch: {
        sourceflag(val, from) {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.specialmoudulename =
            (this.$cache.getParamValue("asset_info") &&
                this.$cache.getParamValue("asset_info").specialmoudulename) ||
            "高端理财";

        const menuModule =
            (this.$cache.getParamValue("menu_module") &&
                this.$cache.getParamValue("menu_module").menus) ||
            [];
        const getValidMenuIds = (menuModule) => {
            const ids = new Set();
            const traverse = (items) => {
                items.forEach((item) => {
                    ids.add(item.menuid);
                    if (item.menu) traverse(item.menu);
                });
            };
            traverse(menuModule);
            return Array.from(ids);
        };
        const validMenuIds = getValidMenuIds(menuModule);
        // 105002-专户公告菜单是否配置
        if (validMenuIds.includes(105002)) {
            this.checkNoticeFlag = true;
        }

        if (validMenuIds.includes(105003)) {
            this.checkNavFlag = true;
        }

        this.conf = this.$util.getConfig().const;
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.doAction();
    },
    methods: {
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets(val, cb);
            }, 500);
        },
        // 获取资产信息
        async getAssets(val, cb) {
            if (!this.$cache.getBinded() && !this.$cache.getCustnoCrm()) {
                return;
            }
            const res = await fundApi.qrySpecialAsset({
                producttype: "@",
                keyword: "",
                pageSize: cb ? 20 : this.pagecount,
                pageNum: val ? 1 : this.pageoffset,
                assetshowtype: this.assetshowtype,
                specialassetflag: "1"
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                const array = res.data.returnList;
                // const array = res.data.returnList
                //     ? res.data.returnList.filter((item) => item.fundshowtype === "4")
                //     : [];
                this.amountTypes[0].val = this.allAssets.specialasset;
                array.forEach((fund, index) => {
                    fund.isBuy = this.$util.checkBuy(fund);
                    fund.isSell = this.$util.checkSell(fund);
                    fund.isChange = this.$util.checkChange(fund);
                    fund.isCurrency = this.$util.checkGeneral(fund);
                });

                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                }
                this.assets = array;
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, array);
                }
            }
        },
        // 跳转到详情
        showDetail(item) {
            this.$router.push("/assetsDetail");
        },
        // 跳转到公告
        showNotice(item) {
            this.$router.push({ name: "fundNotice", query: { fundcode: item.fundcode } });
        },
        // 跳转到净值
        showNav(item) {
            this.$router.push({ name: "fundNav", query: { fundcode: item.fundcode } });
        },
        // 点击申购或赎回按钮
        callbackFn(way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "24" || way == "25") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            this.sdxFundInfo = {};
            const _this = this;
            if (way === "24" || way === "25") {
                let _url = "sellfund";
                if (way === "25") {
                    _url = "orderselllist";
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                // 现金宝取现
                if (fund.assetshowtype == "1") {
                    _url = "currencyredemption";
                }
                this.$router.push({ name: _url, query: { fundcode: fund.fundcode } });
            } else {
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    this.sdxFundInfo = _x;
                                    // 现金宝充值
                                    if (this.sdxFundInfo.assetshowtype == "1") {
                                        this.$router.push({
                                            name: "currencycharge",
                                            query: { fundcode: this.sdxFundInfo.fundcode }
                                        });
                                    } else {
                                        this.controlPopups();
                                    }
                                }
                            });
                        }
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.financial-assets {
    .assets-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 15px 0;
        .deadline-text {
            font-size: 14px;
            color: #999999;
            line-height: 25px;
        }
        .select-class {
            font-size: 14px;
            padding: 5px 15px;
            vertical-align: middle;
        }
        .assets-search {
            padding: 5px 0;
            .input-search {
                width: 350px;
                vertical-align: middle;
                .search-icon {
                    margin: 3px 5px;
                    color: #666666;
                }
                .el-input__inner {
                    height: 40px;
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                }
                .el-input-group__append {
                    background-color: var(--color-primary);
                    color: $text-color6;
                    font-size: $f20;
                    border-color: var(--color-primary);
                    padding: 0 10px;
                }
            }
        }
    }
    .assets-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 16px;
        border-bottom: solid 1px #f1f1f1;

        .assets-item {
            width: 30%;
            height: 110px;
            border-radius: 6px;
            background: #ffffff;
            box-sizing: border-box;
            border: 1px solid #d9d9d9;
            padding-top: 20px;
            padding-left: 32px;

            .amount-type {
                font-size: 14px;
                color: #333333;
                margin-bottom: 10px;
            }
            .assets-text {
                font-size: 32px;
                font-weight: 500;
                color: #000000;
            }
            .add {
                color: $risk5;
            }
            .reduce {
                color: $risk1;
            }
        }
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: #e8e8e8;
        width: 1px;
        height: 12px;
    }
    .fund-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-table td.el-table__cell div {
        color: #333333;
    }
    .el-table td.el-table__cell span {
        color: #333333;
        &.add {
            color: $risk5;
        }
        &.reduce {
            color: $risk1;
        }
    }
    .el-table {
        border: 1px solid #f1f1f1;
    }
    .el-table--fit {
        margin-bottom: 20px;
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus,
    .el-button.is-disabled.is-plain {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
    }
    .el-button--text.is-disabled {
        color: #cccccc;
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }
}
</style>
